import { getWindowObject } from './get-window-object';

export const isLinux = () =>
    /linux/i.test(getWindowObject('navigator')?.userAgent ?? '');
